import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC } from "react";
import styled from "styled-components";
import { LegacyImage } from "components";
import { Features25EmployeeContent } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Features25EmployeeContent;
}

const Employee: FC<Props> = withErrorBoundary(
  ({
    content: {
      elementImage: {
        data: { image },
      },
      elementName,
      elementPosition,
    },
    className = "",
  }) => {
    return (
      <StyledEmployee className={className}>
        <LegacyImage {...image} className="Features25__image" layout="fill" sizes="10vw" />
        <div className="Features25__elementInfo">
          <p className="Font_24_32_600">{elementName}</p>
          <p className="Color_tertiary Font_14_20_450">{elementPosition}</p>
        </div>
      </StyledEmployee>
    );
  },
  {}
);

const StyledEmployee = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;

  .Features25__image {
    position: relative;
    width: 88px;
    height: 88px;
    flex-shrink: 0;
  }

  .Features25__elementInfo {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
  }
`;

gql`
  fragment Features25EmployeeContent on ComponentNestedFeatures25CommitteeElement {
    id
    elementName
    elementPosition
    elementImage {
      data {
        image: attributes {
          alt: alternativeText
          src: hash
        }
      }
    }
  }
`;

export { Employee };
